const numberWithCommas = (number) => {
    let integer = number.toString().split('.')[0];
    number.toString().split('.').length > 1 ?
        number = integer.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +  '.' + number.toString().split('.')[1] :
        number = integer.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return number;
}

export {
    numberWithCommas,
}